module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-22.ae8737b5.jpg";